module.exports = __webpack_public_path__ + "img/clock.e376d467.png";